import axios from 'axios';

// WOW animated
const wow = new WOW({
    boxClass:     'wow', // default
    animateClass: 'animated', // default
    offset:       0, // default
    mobile:       true, // default
    live:         true // default
});
wow.init();

if(document.querySelector('[data-show-on]')) {
    const checkTransportMode = () => {
        const selectedTransportMode = document.querySelector('[name="transport_method"]');

        const hiddenElement = document.querySelector('[data-show-on="' + selectedTransportMode.value + '"]');
        const otherElements = document.querySelectorAll('[data-show-on]:not([data-show-on="' + selectedTransportMode.value + '"])');
        if(hiddenElement) {
            otherElements.forEach(element => element.style.height = 0);
            hiddenElement.style.height = hiddenElement.scrollHeight + 'px';
        }
    }

    document.querySelector('[name="transport_method"]').addEventListener('change', checkTransportMode);

    checkTransportMode();

    const quotationForm = document.getElementById('quotation-form');
    quotationForm.addEventListener('submit', function(event) {
        event.preventDefault();

        let formData = new FormData(this);
        formData.append('g-recaptcha-response', grecaptcha.getResponse());
        let validationAlert = document.getElementById('quotation-form-validation');

        validationAlert.classList.add('hidden');
        validationAlert.classList.remove('alert-danger');

        quotationForm.querySelectorAll('.invalid-feedback').forEach((element) => {
            element.classList.add('d-none');
            element.innerHTML = '';
        });

        quotationForm.querySelectorAll('.is-invalid').forEach(element => element.classList.remove('is-invalid'));

        axios.post(quotationForm.action, formData).then(response => {
            if(response.data.success) {
                validationAlert.innerHTML = response.data.message;
                validationAlert.classList.add('alert-success');
                validationAlert.classList.remove('hidden');

                quotationForm.innerHTML = '';

                let y = document.querySelector('.quotation-container').getBoundingClientRect().top + window.pageYOffset - document.getElementById('mainNav').scrollHeight;
                window.scrollTo({top: y, behavior: 'smooth'});
            }
        }).catch(exception => {
            grecaptcha.reset();
            if(exception.response.data.errors) {
                for(let error in exception.response.data.errors) {
                    let el = document.querySelector('[name="' + error + '"]');
                    el.classList.add('is-invalid');
                    if(el.parentNode.querySelector('.d-none') !== null) {
                        el.parentNode.querySelector('.d-none').innerHTML = exception.response.data.errors[error];
                        el.parentNode.querySelector('.d-none').classList.remove('d-none');
                    }
                }

                let y = document.querySelector('.is-invalid').getBoundingClientRect().top + window.pageYOffset - document.getElementById('mainNav').scrollHeight;
                window.scrollTo({top: y, behavior: 'smooth'});

                checkTransportMode();
            }
        });
    });
}

document.addEventListener("DOMContentLoaded", function() {
    var lazyBackgrounds = [].slice.call(document.querySelectorAll(".lazy-background"));

    if("IntersectionObserver" in window) {
        let lazyBackgroundObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if(entry.isIntersecting) {
                    entry.target.classList.add("visible");
                    entry.target.style.backgroundImage = 'url("' + entry.target.dataset.backgroundImgReplace + '")';
                    entry.target.classList.remove('lazy-background');
                    lazyBackgroundObserver.unobserve(entry.target);
                }
            });
        });

        lazyBackgrounds.forEach(function(lazyBackground) {
            lazyBackgroundObserver.observe(lazyBackground);
        });
    }

    var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));

    if("IntersectionObserver" in window) {
        let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if(entry.isIntersecting) {
                    let lazyImage = entry.target;
                    lazyImage.src = lazyImage.dataset.src;
                    //lazyImage.srcset = lazyImage.dataset.srcset;
                    lazyImage.classList.remove("lazy");
                    lazyImageObserver.unobserve(lazyImage);
                }
            });
        });

        lazyImages.forEach(function(lazyImage) {
            lazyImageObserver.observe(lazyImage);
        });
    } else {
        // Possibly fall back to a more compatible method here
    }
});

// GRIDZY RESPONSIVE CALCULATE (BASED ON viewportWidth)
function computeDesiredElementHeight() {
    var resultValue,
        viewportWidth = document.documentElement.clientWidth;

    if(viewportWidth > 1000) {
        resultValue = 300;
    } else if(viewportWidth > 500) {
        resultValue = 150;
    } else {
        resultValue = 100;
    }

    return resultValue;
};

if(document.getElementById('contact-form')) {
    let contactForm = document.getElementById('contact-form');
    contactForm.addEventListener('submit', function(event) {
        event.preventDefault();

        let formData = new FormData(this);
        formData.append('g-recaptcha-response', grecaptcha.getResponse());
        let validationAlert = document.getElementById('contact-form-validation');

        validationAlert.classList.add('hidden');
        validationAlert.classList.remove('alert-danger');
        axios.post(contactForm.action, formData).then(response => {
            if(response.data.success) {
                validationAlert.innerHTML = response.data.message;
                validationAlert.classList.add('alert-success');
                validationAlert.classList.remove('hidden');

                contactForm.innerHTML = '';

                let items = document.getElementById('intake-form').querySelectorAll(['input', 'textarea', '.g-recaptcha', 'button']);
                for(let item in items) {
                    items[item].parentNode.removeChild(items[item]);
                }
            }
        }).catch(exception => {
            grecaptcha.reset();
            if(exception.response.data.errors) {
                for(let error in exception.response.data.errors) {
                    let el = document.querySelector('[name="' + error + '"]');
                    el.classList.add('is-invalid');
                    if(el.parentNode.querySelector('.d-none') !== null) {
                        el.parentNode.querySelector('.d-none').classList.remove('d-none');
                    }
                }
            }
        });
    });
}

const invitationForm = document.getElementById('invitation-form');
if(invitationForm) {
    // Er is geen sticky navigatie op de jubileumpagina; val terug op een vaste marge.
    const invitationScrollTo = (element) => {
        if(!element) {
            return;
        }

        const nav    = document.getElementById('mainNav');
        const offset = nav ? nav.scrollHeight : 40;

        window.scrollTo({
            top:      element.getBoundingClientRect().top + window.pageYOffset - offset,
            behavior: 'smooth'
        });
    };

    // 'N.v.t.' vult de bedrijfsnaam en blokkeert het veld, zodat relaties die
    // op persoonlijke titel komen toch verder kunnen.
    const companyField = invitationForm.querySelector('[name="company"]');
    const companyNa    = invitationForm.querySelector('[name="company_na"]');

    if(companyField && companyNa) {
        const companyToggle = invitationForm.querySelector('.jub-na-toggle');

        const applyCompanyNa = () => {
            if(companyToggle) {
                companyToggle.classList.toggle('is-active', companyNa.checked);
            }

            if(companyNa.checked) {
                companyField.dataset.previousValue = companyField.value;
                companyField.value    = companyField.dataset.naValue || '';
                companyField.readOnly = true;
                companyField.classList.add('is-na');
                companyField.classList.remove('is-invalid');
            } else {
                companyField.value    = companyField.dataset.previousValue || '';
                companyField.readOnly = false;
                companyField.classList.remove('is-na');
            }
        };

        companyNa.addEventListener('change', applyCompanyNa);

        // Typen in het veld heft de keuze weer op.
        companyField.addEventListener('focus', () => {
            if(companyNa.checked) {
                companyNa.checked = false;
                applyCompanyNa();
            }
        });

        applyCompanyNa();
    }

    invitationForm.addEventListener('submit', function(event) {
        event.preventDefault();

        const submitButton = invitationForm.querySelector('[type="submit"]');
        let formData       = new FormData(this);
        formData.append('g-recaptcha-response', grecaptcha.getResponse());
        let validationAlert = document.getElementById('invitation-form-validation');

        validationAlert.classList.add('hidden');
        validationAlert.classList.remove('jub-alert-danger');

        invitationForm.querySelectorAll('.invalid-feedback').forEach((element) => {
            element.classList.add('d-none');
            element.innerHTML = '';
        });

        invitationForm.querySelectorAll('.is-invalid').forEach(element => element.classList.remove('is-invalid'));

        if(submitButton) {
            submitButton.disabled  = true;
            submitButton.innerHTML = invitationForm.dataset.submittingLabel || 'Even geduld...';
        }

        axios.post(invitationForm.action, formData).then(response => {
            if(response.data.success) {
                invitationForm.innerHTML = '<div class="jub-thanks">' +
                    '<i class="fas fa-glass-cheers"></i>' +
                    '<h3>' + (invitationForm.dataset.thanksTitle || '') + '</h3>' +
                    '<p>' + response.data.message + '</p>' +
                    '</div>';

                invitationScrollTo(document.getElementById('aanmelden'));
            }
        }).catch(exception => {
            grecaptcha.reset();

            if(submitButton) {
                submitButton.disabled  = false;
                submitButton.innerHTML = invitationForm.dataset.submitLabel || 'Aanmelding versturen';
            }

            const errors = exception.response && exception.response.data ? exception.response.data.errors : null;

            if(!errors) {
                validationAlert.innerHTML = invitationForm.dataset.error || 'Er ging iets mis bij het versturen.';
                validationAlert.classList.add('jub-alert-danger');
                validationAlert.classList.remove('hidden');

                return;
            }

            for(let error in errors) {
                let el = invitationForm.querySelector('[name="' + error + '"]');
                if(!el) {
                    continue;
                }

                el.classList.add('is-invalid');

                // Bij een samengesteld veld hoort de rand om de hele groep.
                const group = el.closest('.jub-input-group');
                if(group) {
                    group.classList.add('is-invalid');
                }

                let feedback = (group ? group.parentNode : el.parentNode).querySelector('.invalid-feedback');
                if(feedback !== null) {
                    feedback.innerHTML = errors[error];
                    feedback.classList.remove('d-none');
                }
            }

            invitationScrollTo(invitationForm.querySelector('.is-invalid'));
        });
    });
}

(function($) {
    "use strict"; // Start of use strict

    // Append .background-image-holder <img>'s as CSS backgrounds
    $('.background-image-holder').each(function() {
        var imgSrc = $(this).children('img').attr('src');
        $(this).css('background', 'url("' + imgSrc + '")');
        $(this).children('img').hide();
        $(this).css('background-position', 'initial');
    });

    // MAP
    $('.map-holder').click(function() {
        $(this).addClass('interact');
    });

    if($('.map-holder').length) {
        $(window).scroll(function() {
            if($('.map-holder.interact').length) {
                $('.map-holder.interact').removeClass('interact');
            }
        });
    }

    // Gridzy
    if($.fn.gridzy) {
        $('.gridzy').gridzy({
            spaceBetween:         12,
            desiredElementHeight: computeDesiredElementHeight
        });
    }

    // Modulobox - wordt niet geladen op pagina's zonder galerij
    if(typeof ModuloBox !== 'undefined') {
    var modulobox = new ModuloBox({
        mediaSelector:      '.gallery figure > a, .hidden-gallery div',
        loop:               3,
        history:            true,
        controls:           ['zoom', 'play', 'fullScreen', 'download', 'share', 'close'],
        shareButtons:       ['facebook', 'googleplus', 'twitter', 'pinterest', 'linkedin', 'reddit', 'stumbleupon', 'tumblr', 'blogger', 'buffer', 'digg', 'evernote'],
        videoMaxWidth:      1440,
        minZoom:            1,
        zoomTo:             1.8,
        mouseWheel:         false,
        contextMenu:        false,
        scrollToZoom:       true,
        captionSmallDevice: false,
        thumbnails:         true,
        thumbnailsNav:      'centered',
        thumbnailSizes:     {
            1920: {
                width:  110,
                height: 80,
                gutter: 10
            },
            1280: {
                width:  90,
                height: 65,
                gutter: 10
            },
            680:  {
                width:  0,
                height: 0,
                gutter: 0
            }
        }
    });

    modulobox.on('beforeOpen.modulobox', function(gallery, index) {

        if(window.cubeRAF) {

            cancelAnimationFrame(window.cubeRAF);
            window.cubeRAF = false;

        }

    });

    modulobox.on('afterClose.modulobox', function(gallery, index) {

        if(typeof Event === 'function' && !window.cubeRAF) {
            window.dispatchEvent(new Event('scroll'));
        }

    });

    modulobox.init();
    }

    // Smooth scrolling using jQuery easing
    $('a.js-scroll-trigger[href*="#"]:not([href="#"])').click(function() {
        if(location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target     = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if(target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top - 150
                }, 1000, "easeInOutExpo");
                return false;
            }
        }
    });

    // Parallax header
    $(function() {
        // 	init scrollmagic
        var controller = new ScrollMagic.Controller();

        //  HEADER BACKGROUND IMAGE SCROLL
        $(".page-title").each(function() {

            var bg = $(this).find(".background-image");

            // Add tweenmax for backgroundParallax
            /*var parallax = TweenMax.from(bg, 1, {
                y:    '-20%',
                ease: Power0.easeNone
            });

            // Create scrollmagic scene
            var parallaxScene = new ScrollMagic.Scene({
                triggerElement: this, // <-- Use this to select current element
                triggerHook:    1,
                duration:       '200%',
            })
                .setTween(parallax)
                .addTo(controller);
                */
        });
    });

    // Closes responsive menu when a scroll trigger link is clicked
    $('.js-scroll-trigger').click(function() {
        $('.navbar-collapse').collapse('hide');
    });

    // Collapse Navbar
    var navbarCollapse = function() {
        if(!$("#mainNav").length || !$("#scroll-indicator").length) {
            return;
        }

        if($("#scroll-indicator").offset().top > 80) {
            $("#mainNav").addClass("navbar-shrink");
        } else {
            $("#mainNav").removeClass("navbar-shrink");
        }
    };
    // Collapse now if page is not at top
    navbarCollapse();
    // Collapse the navbar when page is scrolled
    $(window).scroll(navbarCollapse);

})(jQuery); // End of use strict

//3D EFFECT
$(document).mousemove(function(event) {
    $(".dots-move-1").each(function(index, element) {
        var xPos = (event.clientX / $(window).width()) - 1.1,
            yPos = (event.clientY / $(window).height()) - 1.1,
            box  = element;
        TweenLite.to(box, 1, {
            rotationY: xPos * 20,
            rotationX: yPos * 20,
            ease:      Power1.easeOut,
        });
    })
    $(".dots-move-2").each(function(index, element) {
        var xPos = (event.clientX / $(window).width()) - 1,
            yPos = (event.clientY / $(window).height()) - 1,
            box  = element;
        TweenLite.to(box, 1, {
            rotationY: xPos * 20,
            rotationX: yPos * 20,
            ease:      Power1.easeOut,
        });
    })
    $(".dots-move-3").each(function(index, element) {
        var xPos = (event.clientX / $(window).width()) - 0.2,
            yPos = (event.clientY / $(window).height()) - 0.2,
            box  = element;
        TweenLite.to(box, 1, {
            rotationY: xPos * 20,
            rotationX: yPos * 20,
            ease:      Power1.easeOut,
        });
    })
});
